/** 广告系统id枚举 */
export enum AdvIdEnum {
  /** 提现申请中 */
  LOAN_APPLYING = '071c057cdb334ca399de7161977ea25c',
  /** 提现申请页 */
  LOAN_APPLY_POP = '82459ae539c74b1194f8aa3572ad6a09',
  /** 无标签首页 - 天下信用banner位置（圈客逻辑：授信申请过但授信失败用户） */
  LOAN_TAGLESS_HOME_TXXY_BANNER = 'b6df03b7895a4405aa00c4cc4fcdcd86',
  /** 提现结果页 - 天下信用banner位置 */
  LOAN_APPLY_RESULT_TXXY_BANNER = '5f4148f88d534bd58238410399d6e9bd',
}
